export default __webpack_public_path__ + "static/media/play_media.a7039568.svg";